import { InferGetServerSidePropsType } from 'next'
import { ssrProps } from '@utils/server'

import { serveWidgetEventDetailsProps } from '@modules/event/data/server'
import { NoIndexHeader } from '@components/no-index-header'
import { VenuePageProvider } from '@modules/venue/controllers/venue-page-provider'
import { EventDetails } from '@modules/event/controllers/event-details'

export default function EmbeddedWidgetEventPage({
  venue,
  integrations,
  event,
  theme,
  tickets,
  packages,
  layouts,
  sections,
  tables,
  inventoryCalendarMinDate,
  inventoryCalendarMaxDate,
  eventPassed,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <>
      <NoIndexHeader />
      <VenuePageProvider
        venue={venue}
        event={event}
        themeOverride={theme}
        embeddedWidget
        integrations={integrations}
      >
        <EventDetails
          venue={venue}
          event={event}
          tickets={tickets.data}
          packages={packages.data}
          layouts={layouts}
          sections={sections}
          tables={tables}
          embeddedWidget
          inventoryCalendarMinDate={inventoryCalendarMinDate}
          inventoryCalendarMaxDate={inventoryCalendarMaxDate}
          eventPassed={eventPassed}
        />
      </VenuePageProvider>
    </>
  )
}

export const getServerSideProps = ssrProps(serveWidgetEventDetailsProps)
